module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-TINDER.2ea15c7f.png";